import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ANONYMOUS_CONSENTS_HEADER, AnonymousConsent, AnonymousConsentsService} from '@spartacus/core';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class DCPAnonymousConsentsInterceptor implements HttpInterceptor {
  constructor(private anonymousConsentsService: AnonymousConsentsService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has(ANONYMOUS_CONSENTS_HEADER)) {
      const rawConsentsWithPotentialDuplicates = request.headers.get(ANONYMOUS_CONSENTS_HEADER);
      const consents: AnonymousConsent[] = this.anonymousConsentsService.decodeAndDeserialize(
        rawConsentsWithPotentialDuplicates
      );

      const uniqueTemplateCodeNames: string[] = [];
      const filteredConsents = consents.filter((consent) => {
        const knownTemplate: boolean = uniqueTemplateCodeNames.includes(consent.templateCode);
        if (!knownTemplate) {
          uniqueTemplateCodeNames.push(consent.templateCode);
        }
        return !knownTemplate;
      });

      const rawConsents = this.anonymousConsentsService.serializeAndEncode(filteredConsents);

      const clonedRequest = request.clone({
        setHeaders: {
          [ANONYMOUS_CONSENTS_HEADER]: rawConsents,
        },
      });

      return next.handle(clonedRequest);
    } else {
      return next.handle(request);
    }
  }
}
